/* eslint-disable monorepo/no-internal-import */
import {trackCustomerData} from '@aboutyou/legacy-tracking-sdk';
import {useTrackBeginCheckout} from '@aboutyou/tracking';
import {useConvertUserAndSessionToCustomer} from '@aboutyou/tracking/src/trackerComponents/TrackCustomer/useConvertUserAndSessionToCustomer';
import {useTracking} from '@aboutyou/tracking/src/utils/utils';
import {useEffect, useRef} from 'react';

export function useTrackCheckout({
  entryTimestamp,
  label,
}: {
  entryTimestamp: number;
  label: 'internal_checkout' | 'klarna_express_checkout';
}) {
  const trackBeginCheckout = useTrackBeginCheckout();
  const customer = useConvertUserAndSessionToCustomer();
  const {TrackingClient} = useTracking();

  const trackedOnce = useRef(false);

  useEffect(() => {
    if (trackedOnce.current) {
      return;
    }
    if (!customer) {
      return;
    }

    if (customer.type !== 'guest') {
      TrackingClient.track(trackCustomerData({customer}));
      trackBeginCheckout({customerType: customer.type, entryTimestamp, label});

      trackedOnce.current = true;
    }
  }, [TrackingClient, customer, entryTimestamp, trackBeginCheckout, label]);
}
